(() => {
  const lockPage = (locked) => {
    document.documentElement.classList.toggle('sokio-overlay-open', locked);
  };

  const drawer = document.querySelector('[data-sokio-drawer]');

  const closeOverlay = (overlay) => {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    lockPage(false);
  };

  const openOverlay = (overlay) => {
    if (!overlay) return;
    [drawer].forEach((item) => {
      if (item && item !== overlay) closeOverlay(item);
    });
    overlay.hidden = false;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    lockPage(true);
    const firstFocusable = overlay.querySelector('input, button, a');
    if (firstFocusable) firstFocusable.focus({ preventScroll: true });
  };

  document.querySelectorAll('[data-sokio-drawer-open]').forEach((button) => {
    button.addEventListener('click', () => openOverlay(drawer));
  });
  document.querySelectorAll('[data-sokio-drawer-close]').forEach((button) => {
    button.addEventListener('click', () => closeOverlay(drawer));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeOverlay(drawer);
  });

  const normalizeFilterText = (value = '') => value
    .toLocaleLowerCase('es-MX')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const categoryRules = {
    limpiador: { include: ['limpiador', 'limpieza', 'cleanser', 'cleansing', 'jabon', 'soap', 'foam wash'] },
    exfoliante: { include: ['exfoliante', 'exfoliador', 'scrub', 'aha bha pha', 'aha-bha', 'pimple peeling'] },
    tonico: { include: ['tonico', 'toner'] },
    hidratante: {
      include: ['hidratante', 'suero', 'serum', 'ampoule', 'ampolla', 'essence', 'esencia', 'aceite silvestre'],
      exclude: ['sunscreen', 'sun serum', 'sun stick', 'sun cream', 'spf', 'protector solar', 'bloqueador', 'hydration gel water', 'abib hydration gel water'],
    },
    'cuidado-ojos': { include: ['cuidado de ojos', 'cuidado ojos', 'contorno', 'eye & neck', 'eye cream', 'crema ojos', 'ojos'] },
    humectante: {
      include: ['humectante', 'crema', 'cream', 'moisturizer', 'moisturizing cream', 'hydration gel water', 'abib hydration gel water'],
      exclude: ['cleanser', 'cleansing', 'sunscreen', 'sun cream', 'eye', 'ojos', 'cheek', 'blush', 'lip', 'labial'],
      forceInclude: ['crema sol', 'abib hydration gel water'],
    },
    spf: {
      include: ['bloqueador', 'protector solar', 'sunscreen', 'sun serum', 'sun stick', 'sun cream', 'spf'],
      exclude: ['crema sol'],
      forceInclude: ['beauty of joseon ginseng moist sun serum', 'neogen day-light protection airy sunscreen'],
    },
    cuerpo: { include: ['alloeh', 'aloeh', 'aloe 99', 'aloe vera', 'soothing gel', 'exfoliante lavandula', 'exfoliante lavándula', 'corporal', 'body'] },
    maquillaje: { include: ['maquillaje', 'makeup', 'cushion', 'foundation', 'blush', 'cheek', 'rubor'] },
    labios: { include: ['labial', 'lipstick', 'lip liner', 'lip tint', 'water tint', 'lip balm', 'lip mask', 'tinted lip', 'balsamo labial', 'bálsamo labial'] },
    cabello: {
      include: ['cabello', 'hair', 'collagen ceramide coating protein', 'tratamiento capilar'],
      forceInclude: ['elizavecca cer 100'],
    },
    'cuidado-puntual': { include: ['cuidado puntual', 'pimple patch', 'acne patch', 'master patch', 'mascarilla', 'facial mask', 'sheet mask'] },
    herramientas: {
      include: ['herramienta', 'stainless steel', 'gua sha', 'face roller', 'roller', 'rodillo', 'crystal clip', 'squeezer key'],
      exclude: ['elizavecca', 'cer 100', 'collagen ceramide coating protein'],
    },
    accesorios: { include: ['accesorio', 'mirror', 'espejo', 'peine', 'comb', 'bolsa', 'bag', 'tote', 'candle', 'vela', 'gift card', 'tarjeta de regalo', 'crystal clip', 'squeezer key', 'clip', 'key'] },
  };

  document.querySelectorAll('.sk-collection').forEach((collection) => {
    const requestedCategory = normalizeFilterText(new URLSearchParams(window.location.search).get('category') || '');
    const category = Object.keys(categoryRules).includes(requestedCategory) || requestedCategory === 'kits'
      ? requestedCategory
      : '';
    const productGrid = collection.querySelector('[data-sokio-product-grid]');
    const productCards = productGrid ? [...productGrid.querySelectorAll('[data-sokio-product-card]')] : [];
    const kitsSection = collection.querySelector('[data-sokio-kits-section]');
    const emptyState = collection.querySelector('[data-sokio-category-empty]');

    collection.querySelectorAll('[data-sokio-category-link]').forEach((link) => {
      link.classList.toggle('is-active', normalizeFilterText(link.dataset.sokioCategoryLink || '') === category);
    });

    if (!category) {
      if (productGrid) productGrid.hidden = false;
      if (kitsSection) kitsSection.hidden = false;
      if (emptyState) emptyState.hidden = true;
      return;
    }

    if (category === 'kits') {
      if (productGrid) productGrid.hidden = true;
      if (kitsSection) kitsSection.hidden = false;
      if (emptyState) emptyState.hidden = true;
      return;
    }

    if (kitsSection) kitsSection.hidden = true;
    if (productGrid) productGrid.hidden = false;

    const rule = categoryRules[category] || { include: [] };
    let visibleCount = 0;
    productCards.forEach((card) => {
      const tokens = normalizeFilterText(card.dataset.sokioProductTokens || '');
      const hasIncludedTerm = rule.include.some((term) => tokens.includes(normalizeFilterText(term)));
      const hasExcludedTerm = (rule.exclude || []).some((term) => tokens.includes(normalizeFilterText(term)));
      const hasForcedTerm = (rule.forceInclude || []).some((term) => tokens.includes(normalizeFilterText(term)));
      const visible = hasForcedTerm || (hasIncludedTerm && !hasExcludedTerm);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (emptyState) emptyState.hidden = visibleCount > 0;
  });

  document.querySelectorAll('[data-sokio-favorites]').forEach((favorites) => {
    const tabs = [...favorites.querySelectorAll('[data-favorite-tab]')];
    const panels = [...favorites.querySelectorAll('[data-favorite-slide]')];
    const count = favorites.querySelector('[data-favorite-count]');
    let activeIndex = Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active')));
    let timer;

    const activate = (index, restart = true) => {
      activeIndex = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === activeIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === activeIndex;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
        const video = panel.querySelector('video');
        if (!video) return;
        if (active) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
      if (count) {
        count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(tabs.length).padStart(2, '0')}`;
      }
      if (restart) {
        window.clearInterval(timer);
        timer = window.setInterval(() => activate(activeIndex + 1, false), 5200);
      }
    };

    tabs.forEach((tab, index) => tab.addEventListener('click', () => activate(index)));
    if (tabs.length) activate(activeIndex);
  });

  document.querySelectorAll('[data-sokio-locations]').forEach((locations) => {
    const triggers = [...locations.querySelectorAll('[data-location-trigger]')];
    const maps = [...locations.querySelectorAll('[data-location-map]')];

    const activateLocation = (index) => {
      triggers.forEach((trigger, triggerIndex) => {
        trigger.classList.toggle('is-active', triggerIndex === index);
      });
      maps.forEach((map, mapIndex) => {
        const active = mapIndex === index;
        map.classList.toggle('is-active', active);
        map.hidden = !active;
      });
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('mouseenter', () => activateLocation(index));
      trigger.addEventListener('focus', () => activateLocation(index));
    });
  });

  document.querySelectorAll('[data-sokio-newsletter]').forEach((newsletter) => {
    const storageKey = 'sokio-newsletter-dismissed';
    if (window.sessionStorage.getItem(storageKey) === 'true') {
      newsletter.hidden = true;
      return;
    }
    requestAnimationFrame(() => newsletter.classList.add('is-visible'));
    newsletter.querySelectorAll('[data-sokio-newsletter-close]').forEach((button) => {
      button.addEventListener('click', () => {
        newsletter.classList.remove('is-visible');
        window.sessionStorage.setItem(storageKey, 'true');
        window.setTimeout(() => {
          newsletter.hidden = true;
        }, 350);
      });
    });
  });

  const accountLogin = document.querySelector('.sk-account-login');
  if (accountLogin) {
    const loginForm = accountLogin.querySelector('#login-form');
    const recoverForm = accountLogin.querySelector('#login-recover');
    const showRecover = () => {
      if (loginForm) loginForm.hidden = true;
      if (recoverForm) recoverForm.hidden = false;
      recoverForm?.querySelector('input')?.focus();
    };
    const showLogin = () => {
      if (recoverForm) recoverForm.hidden = true;
      if (loginForm) loginForm.hidden = false;
      loginForm?.querySelector('input')?.focus();
    };
    accountLogin.querySelector('[data-sokio-recover-open]')?.addEventListener('click', showRecover);
    accountLogin.querySelector('[data-sokio-recover-close]')?.addEventListener('click', showLogin);
  }

  document.querySelectorAll('[data-sokio-product]').forEach((product) => {
    const media = [...product.querySelectorAll('[data-sokio-product-media]')];
    const thumbs = [...product.querySelectorAll('[data-sokio-product-thumb]')];

    const showMedia = (index) => {
      media.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.hidden = !active;
        const video = item.querySelector('video');
        if (!video) return;
        if (active) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', String(active));
      });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));

    const variantPicker = product.querySelector('[data-sokio-variants]');
    if (variantPicker) {
      const variantData = JSON.parse(variantPicker.querySelector('script[type="application/json"]').textContent);
      const form = product.querySelector('form[data-type="add-to-cart-form"]');
      const idInput = form && form.querySelector('input[name="id"]');
      const addButton = form && form.querySelector('[name="add"]');
      const addButtonLabel = addButton && addButton.querySelector('span:first-child');
      const price = product.querySelector('[data-sokio-product-price]');

      // Use the image assigned to the Shopify variant. If no image was assigned,
      // match its tone to the images already present in this product's gallery.
      const normalizeMediaText = (value = '') => String(value)
        .toLocaleLowerCase('es-MX')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
      const mediaInfo = media.map((item) => {
        const source = item.dataset.sokioProductMediaSource || '';
        const filename = source.split('?')[0].split('/').pop() || '';
        let decodedFilename = filename;
        try { decodedFilename = decodeURIComponent(filename); } catch (_) { /* Keep original filename. */ }
        return {
          id: String(item.dataset.sokioProductMediaId || ''),
          filename: normalizeMediaText(decodedFilename),
          alt: normalizeMediaText(item.dataset.sokioProductMediaAlt || ''),
        };
      });
      const colorAliases = {
        rojo: 'red', rosa: 'pink', morado: 'purple', naranja: 'orange',
        cafe: 'brown', marron: 'brown', verde: 'green', azul: 'blue',
        blanco: 'white', negro: 'black', transparente: 'clear',
      };
      const containsTerm = (text, term) => Boolean(term) && (` ${text} `).includes(` ${term} `);

      const findVariantMediaIndex = (variant) => {
        if (variant.media_id) {
          const assignedIndex = mediaInfo.findIndex((item) => item.id === String(variant.media_id));
          if (assignedIndex >= 0) return assignedIndex;
        }
        for (const option of variant.options) {
          const normalizedOption = normalizeMediaText(option);
          const words = normalizedOption.split(' ').filter((word) => word.length >= 3 && !['color', 'tono', 'shade', 'with', 'con'].includes(word));
          const terms = [...new Set([
            normalizedOption,
            ...words,
            ...words.map((word) => colorAliases[word]).filter(Boolean),
          ])].filter((term) => term.length >= 3);
          for (const term of terms) {
            const byFilename = mediaInfo.findIndex((item) => containsTerm(item.filename, term));
            if (byFilename >= 0) return byFilename;
            const byAlt = mediaInfo.findIndex((item) => containsTerm(item.alt, term));
            if (byAlt >= 0) return byAlt;
          }
        }
        return -1;
      };

      const variantMedia = new Map(variantData.map((variant) => [String(variant.id), findVariantMediaIndex(variant)]));
      // When all but one shade have an identified image and each shade has one
      // gallery image, the remaining image belongs to the remaining shade.
      if (variantData.length === media.length) {
        const mapped = [...variantMedia.values()].filter((index) => index >= 0);
        if (mapped.length === variantData.length - 1 && new Set(mapped).size === mapped.length) {
          const remainingIndex = media.findIndex((_, index) => !mapped.includes(index));
          const remainingVariant = variantData.find((variant) => variantMedia.get(String(variant.id)) < 0);
          if (remainingIndex >= 0 && remainingVariant) variantMedia.set(String(remainingVariant.id), remainingIndex);
        }
      }

      const showVariantMedia = (variant) => {
        const index = variantMedia.get(String(variant.id));
        if (index !== undefined && index >= 0) showMedia(index);
      };

      const selectedOptions = () => [...variantPicker.querySelectorAll('fieldset')].map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : '';
      });

      variantPicker.addEventListener('change', () => {
        const options = selectedOptions();
        const variant = variantData.find((item) => item.options.every((option, index) => option === options[index]));
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addButtonLabel) addButtonLabel.textContent = 'No disponible';
          return;
        }
        if (idInput) {
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (price) price.textContent = variant.price;
        if (addButton) addButton.disabled = !variant.available;
        if (addButtonLabel) addButtonLabel.textContent = variant.available ? 'Añadir a la bolsa' : 'Agotado';
        showVariantMedia(variant);
        window.history.replaceState({}, '', `${variantPicker.dataset.url}?variant=${variant.id}`);
      });

      const initialOptions = selectedOptions();
      const initialVariant = variantData.find((item) => item.options.every((option, index) => option === initialOptions[index]));
      if (initialVariant) showVariantMedia(initialVariant);
    }
  });

  document.querySelectorAll('[data-sokio-read-more]').forEach((container) => {
    const button = container.querySelector('[data-sokio-read-more-button]');
    if (!button) return;
    button.addEventListener('click', () => {
      const expanded = container.classList.toggle('is-expanded');
      button.textContent = expanded ? 'Leer menos' : 'Leer más';
    });
  });

  const normalizeJudgeMePalette = (root = document) => {
    const widget = root.matches?.('.sk-product-reviews__widget')
      ? root
      : root.closest?.('.sk-product-reviews__widget');
    const widgets = widget
      ? [widget]
      : [...root.querySelectorAll?.('.sk-product-reviews__widget') || []];

    widgets.forEach((widget) => {
      widget.querySelectorAll('*').forEach((element) => {
        element.style.setProperty('color', '#65705B', 'important');
        element.style.setProperty('border-color', 'rgba(101, 112, 91, .45)', 'important');
        element.style.setProperty('box-shadow', 'none', 'important');

        const action = element.closest('.jdgm-write-rev-link, .jdgm-submit-rev, .jdgm-btn, button[class*="jdgm"]');
        const isAction = Boolean(action && widget.contains(action));
        const isBar = element.matches('.jdgm-histogram__bar-content');
        if (isAction || isBar) {
          element.style.setProperty('background-color', '#65705B', 'important');
          if (isAction) element.style.setProperty('color', '#FBFBFA', 'important');
        } else {
          element.style.setProperty('background-color', 'transparent', 'important');
        }

        if (element.matches('.jdgm-checkmark, [class*="transparency"], [class*="medal"], [class*="diamond"]')) {
          element.style.setProperty('display', 'none', 'important');
        }

        if (element.matches('svg, svg *')) {
          element.style.setProperty('fill', '#65705B', 'important');
          element.style.setProperty('stroke', '#65705B', 'important');
        }
      });
    });
  };

  normalizeJudgeMePalette();
  [250, 750, 1500, 3000].forEach((delay) => {
    window.setTimeout(() => normalizeJudgeMePalette(), delay);
  });
  const judgeMeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeJudgeMePalette(node);
      });
    });
  });
  judgeMeObserver.observe(document.body, { childList: true, subtree: true });
})();
